import { FormFieldTypes } from "../../../components/finalForms/libs/data/formFieldType";
import { GridColumnType } from "../../../data/gridColumnType";
import { validationTypes } from "../../../components/finalForms/libs/data/ValidationTypes";


const initState = {
  userId: "",
  teamName: "",
  isActive: ""
};

export const teamsFormData = {
  name: "Team Form",
  initialState: initState,
  section: [
    {
      sectionId: 'teamSection',
      title: "Team Form",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-2 mb-2",
      },
      wrapperTemplate: <div className="form-card row"></div>,
      fields: [
        {
          id: "teamName",
          label: "Team Name",
          Field_Name: "team name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "teamName",
          fieldSetting: {
            placeholder: "Please Enter Team Name",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-6 mb-2 validation-left-0",
          },
        },
        {
          id: "userId",
          label: "Responsible User",
          Field_Name: "responsible user",
          fieldType: FormFieldTypes.SELECT,
          dataField: "userId",
          fieldSetting: {
            placeholder: "Please Select Responsible User",
            allowSpace: true,
            options: [],
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-4 validation-left-0",
          },

        },
        {
          id: "checkbox",
          label: "IsActive",
          Field_Name: "isactive",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isActive",
          fieldSetting: {
            allowSpace: true,
          },
          style: {
            containerCss: "col-lg-4 col-md-6 mb-2 validation-left-0 pt-3",
          },
        }
      ]
    }
  ]
}

export const TeamsGridConfig = {
  columns: [
    {
      name: "Team Name",
      fieldName: "teamName",
    },
    {
      name: "Responsible User",
      fieldName: "responsibleUser",
    },
    {
      name: "Status",
      colType: GridColumnType.CHECKBOX,
      fieldName: "isActive",
      allowShort: false,
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
      },
    },
  ],
};
